import {ListItemProps} from 'component/partial/MetricSection/MetricSection';

import {MetricsSection} from '/constant/TestIDs';
import {
  REPORT_COACHES_ABOVE_RANK,
  REPORT_COACHES_AT_RANK,
  REPORT_COACHES_BELOW_RANK,
} from '/enum/records.enum';
import {useTranslation} from '/provider/TranslationProvider';

import {
  RankPerformanceSectionHookReturn,
  RankPerformanceSectionProps,
} from './RankPerformanceSection.types';

export const useRankPerformanceSection = ({
  aboveRank = 0,
  atRank = 0,
  belowRank = 0,
  onShowReport = () => {},
  onShowInfoPopover = () => {},
}: RankPerformanceSectionProps): RankPerformanceSectionHookReturn => {
  const {tt, ts} = useTranslation(
    'screen.teams.section.rankPerformanceSection',
  );

  const listItems: ListItemProps[] = [
    {
      label: tt('aboveRank', 'Above Rank'),
      value: aboveRank,
      recordsName: REPORT_COACHES_ABOVE_RANK,
      testID: MetricsSection.metricAboveRank,
    },
    {
      label: tt('atRank', 'At Rank'),
      value: atRank,
      recordsName: REPORT_COACHES_AT_RANK,
      testID: MetricsSection.metricAtRank,
    },
    {
      label: tt('belowRank', 'Below Rank'),
      value: belowRank,
      recordsName: REPORT_COACHES_BELOW_RANK,
      testID: MetricsSection.metricBelowRank,
    },
  ];

  const onInfoPress = () =>
    onShowInfoPopover({
      heading: tt('info.heading', 'Rank Performance'),
      body: tt(
        'info.body',
        'View Coaches who are performing (so far this month) Above Rank (hip-hip-hooray!), At Rank (are they looking to do more), and those Below Rank (maybe they need some encouragement).',
      ),
    });

  const onItemPress = ({recordsName, value}: any) =>
    onShowReport({recordsName, loadingData: {total: value}});

  return {
    onInfoPress,
    onItemPress,
    listItems,
    tt,
    ts,
  };
};
